export default [
  {
    path: '/app/product-categories',
    name: 'ProductCategories',
    component: () => import('@/views/Admin/ProductCategories/Index.vue'),
    meta: {
      pageTitle: 'Ürün Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCT_CATEGORIES',
      action: 'read',
    },
  },
  {
    path: '/app/product-categories/add',
    name: 'ProductCategoryAdd',
    component: () => import('@/views/Admin/ProductCategories/Add.vue'),
    meta: {
      pageTitle: 'Ürün Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/product-categories',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCT_CATEGORIES_ADD',
      action: 'read',
    },
  },
  {
    path: '/app/product-categories/edit/:id',
    name: 'ProductCategoryEdit',
    component: () => import('@/views/Admin/ProductCategories/Edit.vue'),
    meta: {
      pageTitle: 'Ürün Kategorileri',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/product-categories',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_PRODUCT_CATEGORIES_EDIT',
      action: 'read',
    },
  },
]
